import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferLightFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
export type AdServerFtCreativeFragment = {
	__typename: 'CreativeFreeTrialContent';
	offerSource?: Types.OfferSource | null;
	offer: {
		__typename: 'Offer';
		id: string;
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		standardWebURL?: string | null;
		package: {
			__typename: 'Package';
			technicalName: string;
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			icon: string;
			iconWide: string;
			maskReferrer?: boolean | null;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	};
};

export const AdServerFtCreativeFragmentDoc = gql`
	fragment AdServerFTCreative on CreativeFreeTrialContent {
		offerSource
		offer {
			...TitleOfferLight
			package {
				technicalName
				planOffers(country: $country, platform: WEB) {
					title
					retailPrice(language: $language)
					isTrial
					durationDays
					retailPriceValue
					retailPriceConverted(language: $language)
					children {
						title
						retailPrice(language: $language)
						isTrial
						durationDays
						retailPriceValue
					}
				}
			}
		}
		__typename
	}
	${TitleOfferLightFragmentDoc}
`;
